import { Button, ButtonGroup, DeleteIcon, DuplicateIcon } from '@bp/ui-components';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { constraintPriorityToSeverity, severityToken } from '../../utils/timetable/severity';
import { useTimetableStore } from '../TimetableGrid/TimetableProvider';
import styles from './Constraints.module.scss';
import { ConstraintPriorities, ConstraintsItemType } from './types';

type ConstraintsItemProps = {
  item: ConstraintsItemType;
  onDuplicate: (item: ConstraintsItemType) => void;
  onDelete: (item: ConstraintsItemType) => void;
};

export const ConstraintsItem = observer(({ item, onDuplicate, onDelete }: ConstraintsItemProps) => {
  const store = useTimetableStore();

  function getPriorityIcon(type: ConstraintPriorities | null) {
    if (!type) return null;
    const token = severityToken(constraintPriorityToSeverity(type));
    return (
      <div title={t(`conditions.priority.${type.toLowerCase()}`)}>
        <token.Icon color={token.color} />
      </div>
    );
  }

  return (
    <div className={styles['condition-item']}>
      <div className={styles['title-wrapper']}>{item.text}</div>
      <div className={styles['actions']}>
        {getPriorityIcon(item.priority)}
        <ButtonGroup>
          <Button
            name='duplicate'
            hierarchy='tertiary'
            disabled={store.readonly}
            onClick={() => onDuplicate(item)}
            icon={<DuplicateIcon className='small' />}
          />
          <Button
            name='delete'
            hierarchy='tertiary'
            disabled={store.readonly}
            onClick={() => onDelete(item)}
            icon={<DeleteIcon className='small' />}
          />
        </ButtonGroup>
      </div>
    </div>
  );
});
